import { Clock, MapPin, Phone, UtensilsCrossed, Package } from 'lucide-react';
import { useCart } from '@/context/CartContext';

const InfoSection = () => {
  const { ordersEnabled } = useCart();

  return (
    <section id="servizi" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            I Nostri Servizi
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {ordersEnabled
              ? 'Ordina le tue pizze preferite e ritirale comodamente al nostro locale.'
              : 'Vieni a trovarci o chiamaci per ordinare le tue pizze preferite.'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Takeaway */}
          <div className="card-elevated p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
              {ordersEnabled
                ? <Package className="h-8 w-8 text-primary" />
                : <Phone className="h-8 w-8 text-primary" />}
            </div>
            <h3 className="text-2xl font-semibold text-foreground mb-2">
              Asporto
            </h3>
            <p className="text-muted-foreground">
              {ordersEnabled
                ? "Ordina online, scegli l'orario di ritiro e passa a ritirare la tua pizza calda e pronta!"
                : 'Chiamaci per ordinare e passa a ritirare la tua pizza calda e pronta!'}
            </p>
          </div>

          {/* Self Service */}
          <div className="card-elevated p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center mx-auto mb-4">
              <UtensilsCrossed className="h-8 w-8 text-accent" />
            </div>
            <h3 className="text-2xl font-semibold text-foreground mb-2">
              Self Service
            </h3>
            <p className="text-muted-foreground">
              Abbiamo posti a sedere all'interno del locale. Ordina e gustati la pizza comodamente da noi!
            </p>
          </div>
        </div>

        {/* Note */}
        <p className="text-center text-sm text-muted-foreground mt-8">Non effettuiamo servizio al tavolo. Solo asporto e self service.

        </p>
      </div>
    </section>);

};

export default InfoSection;